import styled from '@emotion/styled';
import { r } from '../../../shared/lib/responsive';

/** Figma btn/vote — bottom 16px, 좌우 margin 17px, 342×56 @ 375 (투표·결과 공통) */
export const PromoCtaWrap = styled.div`
  position: absolute;
  bottom: var(--cta-bottom);
  left: var(--cta-margin-x);
  right: var(--cta-margin-x);
  height: var(--cta-height);
  pointer-events: auto;
`;

/** 투표·결과 CTA 공통 버튼 크기 (Figma btn/vote 342×56) */
export const PromoCtaButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  min-height: 0;
  padding: 0;
  border: none;
  border-radius: var(--radius-cta);
  font-family: var(--font-sans);
  font-weight: var(--font-weight-bold);
  font-size: var(--type-cta-size);
  line-height: 1;
  transition: background 0.15s ease, transform 0.1s ease;
  cursor: pointer;

  &:active:not(:disabled) {
    transform: scale(0.99);
  }

  &:focus-visible {
    outline: 2px solid var(--color-text-on-dark);
    ${r('outline-offset', 2)}
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;
